
export default {
  setPaymentStatusSorts (state, data) {
    state.paymentStatusSorts = data
  },
  setDishTypeList (state, data) {
    state.dishTypeList = data
  },
  setMealPackageTypeSorts (state, data) {
    state.mealPackageTypeSorts = data
  },
  setMealPackageDropDownList (state, data) {
    state.mealPackageDropDownList = data
  },
  setValidPackageList (state, data) {
    state.validPackageList = data
  },
  setTakeMealStatusSorts (state, data) {
    state.takeMealStatusSorts = data
  },
  setDishesList (state, data) {
    state.dishesList = data
  },
  clearOrderDropDownList (state) {
    state.paymentStatusSorts = []
    state.mealPackageTypeSorts = []
    state.mealPackageDropDownList = []
    state.dishTypeList = []
    state.validPackageList = []
    state.takeMealStatusSorts = []
    state.dishTypeList = []
  }
}



// WEBPACK FOOTER //
// ./src/store/order/mutations.js